import React, { useState, useEffect } from 'react';
import { downloadCsv } from '../common/sharedFunctions';
import MaterialTable from "material-table";
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import { colors } from '../components/Theme/WebTheme';
import { SECONDORY_COLOR } from "../common/sharedFunctions";
import { ThemeProvider } from '@mui/material/styles';
import { Modal, Button, Radio, RadioGroup, FormControlLabel } from '@mui/material'; // Importações do Material-UI
import theme from "styles/tableStyle";
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';

const Withdraws = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    completeWithdraw
  } = api;
  const dispatch = useDispatch();

  const [modalVisible, setModalVisible] = useState(false); // Estado para controlar o modal
  const [selectedRowData, setSelectedRowData] = useState(null); // Dados da linha selecionada
  const [selectedStatus, setSelectedStatus] = useState(''); // Status selecionado
  const [data, setData] = useState([]);
  const withdrawdata = useSelector(state => state.withdrawdata);
  const [selectedFile, setSelectedFile] = useState(null); // Estado para armazenar o arquivo selecionado


  useEffect(() => {
    if (withdrawdata.withdraws) {
      console.log("withdraws", withdrawdata.withdraws);
      setData(withdrawdata.withdraws);
    } else {
      setData([]);
    }
  }, [withdrawdata.withdraws]);

  const handleOpenModal = (rowData) => {
    setSelectedRowData(rowData); // Define os dados da linha selecionada
    setModalVisible(true); // Abre o modal
  };

  const handleCloseModal = () => {
    setModalVisible(false); // Fecha o modal
    setSelectedStatus(''); // Reseta o status selecionado
  };

  const handleSubmitStatus = async () => {
    if (selectedStatus === "concluida" && selectedFile) {
      try {
        // Faz o upload da imagem para o servidor PHP
        const formData = new FormData();
        formData.append("file", selectedFile);

        const response = await fetch("https://pajeutech.com/phpcomprovante/anexa.php", {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (result.success && result.url) {
          // Atualiza o updatedRowData com a URL do comprovante
          const updatedRowData = {
            ...selectedRowData,
            status: selectedStatus,
            urlComprovante: result.url, // URL retornada pelo servidor
          };

          // Envia os dados para o Redux
          dispatch(completeWithdraw(updatedRowData));

          // Fecha o modal
          handleCloseModal();
        } else {
          alert("Erro ao fazer upload da imagem.");
        }
      } catch (error) {
        console.error("Erro ao fazer upload:", error);
        alert("Erro ao fazer upload da imagem.");
      }
    } else if (selectedStatus === "rejeitado") {
      // Caso o status seja rejeitado, não precisa de upload
      const updatedRowData = { ...selectedRowData, status: selectedStatus };
      dispatch(completeWithdraw(updatedRowData));
      handleCloseModal();
    } else {
      alert("Por favor, selecione uma imagem para concluir.");
    }
  };
  const columns = [
    {
      title: 'ID', field: 'id', editable: 'never',
    },
    {
      title: t('requestDate'), field: 'date', defaultSort: 'desc', render: rowData => rowData.date ? moment(rowData.date).format('lll') : null,
      exportTransformer: (rowData) => new Date(rowData.date).toLocaleDateString() + ' ' + new Date(rowData.date).toLocaleTimeString()
    },
    {
      title: t('driver_name'), field: 'name', editable: 'never',
    },
    {
      title: t('amount'), field: 'amount', editable: 'never',
      render: (rowData) =>
        rowData.amount
          ? settings.swipe_symbol
            ? rowData.amount + " " + settings.symbol
            : settings.symbol + " " + rowData.amount
          : settings.swipe_symbol
            ? "0 " + settings.symbol
            : settings.symbol + " 0",
    },
    {
      title: t('processed'), field: 'processed', type: 'boolean', editable: 'never',
    },
    {
      title: t('processDate'), field: 'processDate', render: rowData => rowData.processDate ? moment(rowData.processDate).format('lll') : null,
    },
    { title: t('bankName'), field: 'bankName', hidden: settings.bank_fields === false ? true : false, editable: 'never' },
    { title: t('bankCode'), field: 'bankCode', hidden: settings.bank_fields === false ? true : false, editable: 'never' },
    { title: t('bankAccount'), field: 'bankAccount', hidden: settings.bank_fields === false ? true : false, editable: 'never' }
  ];


  const [selectedRow, setSelectedRow] = useState(null);
  return (
    withdrawdata.loading ? <CircularLoading /> :
      <ThemeProvider theme={theme}>
        <MaterialTable
          title={t('Withdraw_title')}
          columns={columns}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "8px",
            boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
            padding: "20px",
          }}
          data={data}
          onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          options={{
            exportCsv: (columns, data) => {
              let hArray = [];
              const headerRow = columns.map(col => {
                if (typeof col.title === 'object') {
                  return col.title.props.text;
                }
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = data.map(({ tableData, ...row }) => {
                row.date = new Date(row.date).toLocaleDateString() + ' ' + new Date(row.date).toLocaleTimeString()
                row.processDate = row.processDate ? new Date(row.processDate).toLocaleDateString() + ' ' + new Date(row.processDate).toLocaleTimeString() : ''
                let dArr = [];
                for (let i = 0; i < hArray.length; i++) {
                  dArr.push(row[hArray[i]]);
                }
                return Object.values(dArr);
              })
              const { exportDelimiter } = ",";
              const delimiter = exportDelimiter ? exportDelimiter : ",";
              const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
              const csvFileName = 'download.csv';
              downloadCsv(csvContent, csvFileName);
            },
            exportButton: {
              csv: settings.AllowCriticalEditsAdmin,
              pdf: false,
            },
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData.tableData.id ? colors.ROW_SELECTED : colors.WHITE
            }),
            ...TableStyle()
          }}
          localization={localization(t)}
          actions={[
            rowData => ({
              icon: 'check',
              tooltip: t('process_withdraw'),
              disabled: rowData.processed,
              onClick: (event, rowData) => handleOpenModal(rowData) // Abre o modal ao clicar
            }),
          ]}
        />
        {/* Modal para escolher o status */}
        <Modal
          open={modalVisible}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <div style={{ padding: '20px', backgroundColor: 'white', margin: '10% auto', width: '30%', borderRadius: '8px' }}>
            <h2 id="modal-title">{"Transferencia de valores para Motorista"}</h2>
            <RadioGroup
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <FormControlLabel value="concluida" control={<Radio />} label={"Concluida com Sucesso"} />
              <FormControlLabel value="rejeitado" control={<Radio />} label={"Rejeitada"} />
            </RadioGroup>

            {selectedStatus === "concluida" && (
              <div style={{ marginTop: '20px' }}>
                <h2> Anexe abaixo o comprovante de Transferencia</h2>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setSelectedFile(e.target.files[0])} // Salva o arquivo selecionado
                />
              </div>
            )}

            <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
              <Button variant="contained" color="secondary" onClick={handleCloseModal}>
                {t('cancel')}
              </Button>
              <Button variant="contained" color="primary" onClick={handleSubmitStatus}>
                {t('submit')}
              </Button>
            </div>
          </div>
        </Modal>
      </ThemeProvider>
  );
}

export default Withdraws;
